import { createSlice } from '@reduxjs/toolkit';
import { incApi } from 'api/inc-api';

const sliceName = 'merchant';

const merchant = createSlice({
  name: sliceName,
  initialState: {
    current: null,
  },
  reducers: {
    setCurrent: (state, action) => {
      state.current = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      incApi.endpoints.listMerchants.matchFulfilled,
      (state, { payload }) => {
        if (payload?.merchants?.length < 1) return;

        state.current = !state.current
          ? payload.merchants[0].merchantId
          : payload.merchants.find(
              merchant => merchant.merchantId === state.current,
            )?.merchantId ?? payload.merchants[0].merchantId;
      },
    );
  },
});

// ACTIONS
export const merchantActions = {
  ...merchant.actions,
};

export default merchant;
